import { InputNumber, Typography, Spin, Form } from "antd";
import useElements from "../hooks/useElements";

const { Text } = Typography;

export default function MinPpmByElementTab({ form }) {
  const { elements, loading } = useElements([], true);
  const minPpmList = Form.useWatch("minPpmByElement", form) || [];

  const setMinPpmList = (updater) => {
    const next =
      typeof updater === "function" ? updater(minPpmList) : updater;
    form.setFieldsValue({ minPpmByElement: next });
  };

  const handleChange = (elementId, value) => {
    setMinPpmList((prev) => {
      const existing = prev.find((e) => e.elementId === elementId);
      if (existing) {
        return prev.map((e) =>
          e.elementId === elementId
            ? { ...e, minPpm: value }
            : e
        );
      }
      return [...prev, { elementId, minPpm: value }];
    });
  };

  if (loading) return <Spin />;

  return (
    <div style={{ padding: 16 }}>
      {/* 🔑 REGISTRO DEL FIELD */}
      <Form.Item name="minPpmByElement" hidden>
        <input />
      </Form.Item>

      <Text type="secondary">
        Minimum concentration thresholds are expressed in parts per million (ppm).
      </Text>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: 16,
          marginTop: 16,
        }}
      >
        {elements.map((el) => {
          const current = minPpmList.find((e) => e.elementId === el.id);

          return (
            <div key={el.id} style={{ display: "flex", flexDirection: "column" }}>
              <Text strong>{el.name}</Text>

              <InputNumber
                min={0}
                step={0.01}
                placeholder="Optional"
                value={
                  typeof current?.minPpm === "number"
                    ? current.minPpm
                    : null
                }
                onChange={(val) => handleChange(el.id, val)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
